export const SET_API_TOGGLE_INIT = 'SET_API_TOGGLE_INIT';
export const SET_API_TOGGLE_LOADING = 'SET_API_TOGGLE_LOADING';
export const SET_API_TOGGLE_SUCCESS = 'SET_API_TOGGLE_SUCCESS';
export const SET_API_TOGGLE_FAIL = 'SET_API_TOGGLE_FAIL';
export const SET_API_TOGGLE_EMPTY = 'SET_API_TOGGLE_EMPTY';
export const SET_API_DATA = 'SET_API_DATA';
export const SET_URL_PARAMS = 'SET_URL_PARAMS';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js